import React from 'react';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  display: flex;
  align-items: baseline;
`;

const PriceText = styled.span`
  font-size: ${({ small }) => (small ? '24px' : '48px')};
  margin-left: ${({ showPrice }) => showPrice && '4px'};
`;

const PriceCurrency = styled.span`
  position: relative;
  bottom: ${({ small }) => (small ? '8px' : '22px')};
  right: 0px;
`;

const PriceTag = ({ price, currency, small }) => {
  const showPrice = typeof price === 'number';
  return (
    <Wrapper>
      {showPrice && <PriceCurrency small={small}>{currency}</PriceCurrency>}
      <PriceText small={small} showPrice={showPrice}>
        {price}
      </PriceText>
      {showPrice && <span>/mån</span>}
    </Wrapper>
  );
};

export default PriceTag;
